import { updateStudent } from "../../../../api/endpoints/students/students";
import UserPersonalInfo from "../../../../components/personalInfo/UserPersonalInfo";
import { createBrowserHistory } from "history";
import { useAuth } from "../../../../context/AuthContext";

export default function PersonalInfo() {
  const userContext = useAuth();
  const history = createBrowserHistory();
  const afterSubmit = () => {
    history.go(0);
  };

  return (
    <div className="flex h-fit flex-col bg-gray-50  items-center w-full">
      <UserPersonalInfo
        updateUser={updateStudent}
        user={userContext?.currentUser!}
        afterSubmit={afterSubmit}
        isEditable={true}
        showTitle={false}
        stylesClass={"md:bg-white  md:p-6 "}
      />
    </div>
  );
}
